export default 'personalNotes'
